import React, { useContext, useEffect, useState } from "react";
import { Tabs } from "antd";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import Layout from "../layout/Layout";
import CompanyLeft from "../components/company-search/CompanyLeft";
import CompanyContent from "../components/company-search/CompanyContent";
import CompanyNavigation from "../components/company-search/CompanyNavigation";

import ExecutiveLeft from "../components/executive-search/ExecutiveLeft";
import ExecutiveContent from "../components/executive-search/ExecutiveContent";
import ExecutiveNavigation from "../components/executive-search/ExecutiveNavigation";
import LeadContent from "../components/lead-search/LeadContent";
import LeadNavigation, {
  emptyLeadFilters,
} from "../components/lead-search/LeadNavigation";
import LeadLeft from "../components/lead-search/LeadLeft";
import "../assets/css/dynemic-page.css";
import { resetExecutiveFilters } from "./ExecutiveSearch";
import { resetCompanyFilters } from "./CompanySearch";
import { AuthContext } from "../context/AuthContext";

const LeadSearch = ({ tab }) => {
  const [activeTab, setActiveTab] = useState(tab);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isLeadView, isCompanyView, isExecutiveView } =
    useContext(AuthContext);

  useEffect(() => {
    if (!isLeadView) {
      navigate("/dashboard-view");
    }
  }, [isLeadView, navigate]);

  useEffect(() => {
    setActiveTab(tab);
  }, [location, tab]);

  const onChange = (key) => {
    setActiveTab(key);
  };

  useEffect(() => {
    if (activeTab === "1") {
      resetCompanyFilters(dispatch);
    }
    if (activeTab === "2") {
      resetExecutiveFilters(dispatch);
    }
    if (activeTab === "3") {
      emptyLeadFilters(dispatch);
    }
  }, [activeTab, dispatch]);

  const items = [
    {
      key: "1",
      isVisible: isCompanyView,
      label: (
        <span>
          {" "}
          <i className="fa tab-img la la-building"></i>Companies
        </span>
      ),
      children: (
        <div>
          <CompanyNavigation />
          <div id="wrapper">
            <div className="leftmenu">
              <CompanyLeft />
            </div>
            <div className="contentbody shadow">
              <CompanyContent />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      isVisible: isExecutiveView,
      label: (
        <span>
          <i className="fa tab-img la la-user-tie"></i>Executive
        </span>
      ),
      children: (
        <div>
          <ExecutiveNavigation />
          <div id="wrapper">
            <div className="leftmenu">
              <ExecutiveLeft />
            </div>
            <div className="contentbody shadow">
              <ExecutiveContent />
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      isVisible: isLeadView,
      label: (
        <span>
          <i className="fa tab-img las la-user-friends"></i>Leads
        </span>
      ),
      children: (
        <div>
          <LeadNavigation />
          <div id="wrapper">
            <div className="leftmenu">
              <LeadLeft />
            </div>
            <LeadContent />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Layout>
        <div>
          <h3 className="pagetitle">
            {activeTab === "1"
              ? "Search Companies"
              : activeTab === "2"
                ? "Search Executive"
                : "Search Leads"}
          </h3>
          <Tabs
            activeKey={activeTab}
            items={items?.filter((d) => d?.isVisible)}
            onChange={onChange}
            type="card"
          />
        </div>
        {/*         
        <div className="wrapper">
            <CompanyHeader/>
            <div id="wrapper">
                <CompanyLeft/>
                <CompanyContent/>
            </div>
        </div> */}
      </Layout>
    </>
  );
};
export default LeadSearch;
